import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { IdleSignOut } from '@/features/auth/IdleSignOut';
import { signedOutSearch } from '@/features/auth/idleSession';
import { isUnauthorized, sessionQuery } from '@/features/auth/session';
import { AppShell } from '@/layouts/AppShell';
import { identifyStaff } from '@/lib/sentry';

/**
 * Everything under here needs a session. The check runs before any child loads, so a child
 * never renders for a signed-out person, and the login screen learns where to send them
 * back to. A 401 after this tab had a session is the "session expired" state, or the idle
 * limit's when the shared clock says that is what ran out; a 401 on a cold visit is just a
 * login. Every screen under here is also held to the idle limit (ALS-494).
 */
export const Route = createFileRoute('/_app')({
    beforeLoad: async ({ context, location }) => {
        try {
            const user = await context.queryClient.ensureQueryData(sessionQuery);
            identifyStaff(user.id);
            return { user };
        } catch (error) {
            if (isUnauthorized(error)) {
                throw redirect({
                    to: '/login',
                    search: { redirect: location.href, ...signedOutSearch(error.problem) },
                });
            }
            throw error;
        }
    },
    component: () => (
        <AppShell>
            <Outlet />
            <IdleSignOut />
        </AppShell>
    ),
});
